import Icon from '../components/Icon.vue'

Icon.register({"chalkboard-teacher":{"width":640,"height":512,"paths":[{"d":"M208 352C205.6 352 203.2 352.4 200.9 353.1 188 357.3 174.3 360 160 360 145.7 360 132 357.3 119 353.1 116.8 352.4 114.4 352 112 352 49.9 352-0.3 402.5 0 464.6 0.1 490.9 21.7 512 48 512H272C298.3 512 319.9 490.9 320 464.6 320.3 402.5 270.1 352 208 352zM160 320C213 320 256 277 256 224S213 128 160 128 64 171 64 224 107 320 160 320zM592 0H208C181.5 0 160 22.3 160 49.6V96C183.4 96 205.1 102.8 224 113.8V64H576V352H512V288H384V352H307.8C326.9 368.7 340.9 390.7 347.4 416H592C618.5 416 640 393.8 640 366.4V49.6C640 22.3 618.5 0 592 0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chalkboard-teacher.js
// module id = wy4H
// module chunks = 0